/**
 * Identificadores ÚNICOS de las tablas y las barras de filtrado para guardar su estado.
 */
export enum VIEW_KEY {
  CAMPAIGNS_LIST = 'campaigns-list',
  EVENTS_LIST = 'events-list',
  FRAUD_LIST = 'fraud-list',
  OFFERS_LIST = 'offers-list',
  OFFERS_PROVIDERS_LIST = 'offers-providers-list',
  PROVIDERS_LIST = 'providers-list',
}
